export default __webpack_public_path__ + "static/media/right-side.4b150b43.png";